import services from "@/services.js";

export default {
  organizationUsers: ({commit}, id) => {
    return new Promise((resolve, reject) => {
      services.getOrganizationUsers(id)
      .then(({data}) => {
        commit('UPDATE_ORGANIZATION_USERS', data.data)
      })
      .catch(error => {
        reject(error.response.data);
      })
    })
  },

  setIdSender: ({commit}, organizationSenderId) => {
    commit('UPDATE_SENDER_ID', organizationSenderId)
  },

  setTypeSender: ({commit}, typeSender) => {
    commit('UPDATE_SENDER_TYPE', typeSender)
  },
}
